import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./styles/postAuth/profileUpdate.css";

// Lazy load components
const SignIn = React.lazy(() => import("./pages/auth/signIn"));
const SignUp = React.lazy(() => import("./pages/auth/signUp"));
const Dashboard = React.lazy(() => import("./pages/dashboard"));
const Post = React.lazy(() => import("./pages/PostAuth/Post"));
const ViewPost = React.lazy(() => import("./pages/PostAuth/ViewPost"));

// Loading component


const PublicRoute = ({ component }) => {
  const token = localStorage.getItem("token");
  return !token ? component : <Navigate to="/dashboard" />;
};

const PrivateRoute = ({ component }) => {
  const token = localStorage.getItem("token");
  return token ? component : <Navigate to="/signin" />;
};

function AppRoutes() {
  return (
      <Routes>
        <Route path="/signin" element={<PublicRoute component={<SignIn />} />} />
        <Route path="/signup" element={<PublicRoute component={<SignUp />} />} />
        <Route path="/dashboard" element={<PrivateRoute component={<Dashboard />} />} />
        <Route path="/posts" element={<PrivateRoute component={<Post />} />} />
        <Route path="/posts/:id" element={<PrivateRoute component={<ViewPost />} />} />
        <Route path="*" element={<Navigate to="/signin" />} />
      </Routes>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppRoutes />
      </Router>
    </Provider>
  );
}

export default App;
